export default __webpack_public_path__ + "static/media/family1.c10d9acf.jpg";